import { CountryCode } from '../countries';

import { getCountryInfoFromCountryCode } from './getCountryInfo';

export const removeCountryPrefix = (
  value: string,
  countryCode: CountryCode
) => {
  const { dialingCode } = getCountryInfoFromCountryCode(countryCode);

  return value.startsWith(dialingCode)
    ? value.slice(dialingCode.length)
    : value;
};
